<template>
  <div>
    <div class="w-100 d-inline-block bg-introduction">
      <div class="container autoContent">
        <div class="row">
          <div class="col-12 margin-top-3 margin-bottom-3">
            <div class="w-100 d-inline-block text-center">
              <h1 class="half-black fw-bold fw-bold filson-black-family text-uppercase mb-0 text-full-32">
                Return and Refund Policy
              </h1>
            </div>
          </div>
        </div>
        <div class="row margin-bottom-3">
          <div class="col-12">
            <div class="w-100 d-inline-block">
              <h2 class="text-black fw-bold family-filson-bold margin-bottom-3 text-size-24 text-full-24">
                Return and Refund Policy
              </h2>
              <p class="mb-0 text-size-15 text-black family-inter-light text-full-15">
                Thank you for choosing Lush Groom. We strive to provide the highest quality grooming services to all of our clients and their beloved pets. If you are not entirely satisfied with your purchase, we’re here to help.
              </p>
            </div>
            <div class="w-100 d-inline-block margin-top-3">
              <h2 class="text-black fw-bold family-filson-bold margin-bottom-3 text-size-24 text-full-24">
                1. Returns
              </h2>
              <p class="margin-bottom-2 text-size-15 text-black family-inter-light text-full-15">
                1.1 We do not accept returns for services rendered. Once grooming services have been provided, they are considered final.
              </p>
              <p class="margin-bottom-2 text-size-15 text-black family-inter-light text-full-15">
                1.2 If you are unsatisfied with the results of a grooming session, please contact us within 24 hours of the service. We will do our best to address your concerns and arrange for any necessary touch-ups or adjustments.
              </p>
              <p class="margin-bottom-2 text-size-15 text-black family-inter-light text-full-15">
                1.3 In the event of a scheduling error or other mistake on our part, we may offer a complimentary grooming session or other appropriate compensation.
              </p>
            </div>
            <div class="w-100 d-inline-block margin-top-3">
              <h2 class="text-black fw-bold family-filson-bold margin-bottom-3 text-size-24 text-full-24">
                2. Refunds
              </h2>
              <p class="margin-bottom-2 text-size-15 text-black family-inter-light text-full-15">
                2.1 Refunds will only be issued in cases where a grooming service cannot be completed due to extenuating circumstances, such as a pet’s health condition or behavior.
              </p>
              <p class="margin-bottom-2 text-size-15 text-black family-inter-light text-full-15">
                2.2 If a refund is deemed necessary, it will be issued in the original form of payment within [number] business days.
              </p>
              <p class="margin-bottom-2 text-size-15 text-black family-inter-light text-full-15">
                2.3 Refunds will not be issued for services that have already been provided, unless otherwise determined by Lush Groom management.
              </p>
            </div>
            <div class="w-100 d-inline-block margin-top-3">
              <h2 class="text-black fw-bold family-filson-bold margin-bottom-3 text-size-24 text-full-24">
                3. Cancellations
              </h2>
              <p class="margin-bottom-2 text-size-15 text-black family-inter-light text-full-15">
                3.1 If you need to cancel a grooming appointment, please contact us at least 24 hours in advance. Cancellations made less than 24 hours before the scheduled appointment may be subject to a cancellation fee.
              </p>
              <p class="margin-bottom-2 text-size-15 text-black family-inter-light text-full-15">
                3.2 In the event that we need to cancel or reschedule a grooming appointment, we will make every effort to notify you as soon as possible and accommodate your needs.
              </p>
            </div>
            <div class="w-100 d-inline-block margin-top-3">
              <h2 class="text-black fw-bold family-filson-bold margin-bottom-3 text-size-24 text-full-24">
                4. Exceptions
              </h2>
              <p class="margin-bottom-2 text-size-15 text-black family-inter-light text-full-15">
                4.1 Our return and refund policy applies only to grooming services. Products such as pet grooming supplies or accessories may be subject to different return and refund policies, which will be clearly outlined at the time of purchase.
              </p>
              <p class="margin-bottom-2 text-size-15 text-black family-inter-light text-full-15">
                4.2 Any exceptions to our standard return and refund policy will be made at the discretion of Lush Groom management.
              </p>
            </div>
            <div class="w-100 d-inline-block margin-top-3">
              <h2 class="text-black fw-bold family-filson-bold margin-bottom-3 text-size-24 text-full-24">
                5. Contact Us
              </h2>
              <p class="margin-bottom-2 text-size-15 text-black family-inter-light text-full-15">
                If you have any questions or concerns about our Return and Refund Policy, please contact us at +971 52573 5386. We are here to assist you and ensure that you and your pet have a positive experience with Lush Groom.
              </p>
            </div>
          </div>
        </div>
        <div class="row margin-top-1 margin-bottom-0">
          <div class="col-12">
            <ul class="w-100 d-inline-block ps-0 bread-crumb mb-0">
              <li class="float-start margin-right-2">
                <a class="text-black text-size-13 medium-family text-full-13" href="javascript:void(0)">
                <i class="fa fa-home text-black" aria-hidden="true"></i>
                Home /
                </a>
              </li>
              <li class="float-start">
                <a class="text-black text-size-13 medium-family text-full-13" href="javascript:void(0)">
                Refund Policy
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'refundPolicyBannerComponent',
  }
</script>
<style scoped></style>